import { IViewConfiguration } from '@ispm/therapies/interfaces/view-configuration.interface';
import { ConditionalOperator } from '@ispm/shared/constants/conditional-operator.enum';

/**
 * this configuration was created for support cases lower than version 3.0.0
 * @type {IViewConfiguration}
 */
export const DEFAULT_VIEW_CONFIGURATION: IViewConfiguration = {
  'subject_selection_section': {
    'resources': [
      {
        'type': 'form',
        'name': 'therapies',
        'payload': {
          'formConfig': [
            {
              'label': '',
              'cssClass': 'full-size-item no-margin-right',
              'name': 'immunotherapy',
              'type': 'widget',
              'options': {
                'component': 'IMMUNOTHERAPY'
              },
              'widgetPayload': {
                'viewMode': true,
                'show': false,
                'editAllowed': false
              },
              'reflects': [
                {
                  'affectedField': 'immunotherapy',
                  'applyRegex': 'null',
                  'removeProperty': true
                }
              ]
            }
          ]
        }
      },
      {
        'type': 'list',
        'name': 'therapies',
        'subjectIdPath': 'molecularFinding.id',
        'subTitle': 'Immunotherapy related findings',
        'conditions': [{
          'path': 'molecularFinding',
          'value': null,
          'operator': ConditionalOperator.NEQ
        }],
        'fields': [
          {
            'label': 'Tier',
            'path': 'tier',
            'type': 'tier'
          },
          {
            'label': 'Genetic test',
            'path': 'pathway',
            'type': 'text'
          },
          {
            'label': 'Level',
            'path': 'alteration',
            'type': 'text'
          },
          {
            'label': 'Trials',
            'path': 'trials',
            'type': 'counter'
          },
          {
            'label': 'Include in report',
            'type': 'include_in_report'
          }
        ]
      },
      {
        'type': 'list',
        'name': 'therapies',
        'subjectIdPath': 'aberration.id',
        'subTitle': 'Therapy Matches',
        'conditions': [{
          'path': 'molecularFinding',
          'value': null,
          'operator': ConditionalOperator.EQ
        }],
        'fields': [
          {
            'label': 'Tier',
            'path': 'tier',
            'type': 'tier'
          },
          {
            'label': 'Gene',
            'path': 'gene.name',
            'type': 'text'
          },
          {
            'label': 'Aberration',
            'path': 'alteration',
            'type': 'text'
          },
          {
            'label': 'Seq. change',
            'path': 'codingSeqChange',
            'type': 'text'
          },
          {
            'label': 'Trials',
            'path': 'trials',
            'type': 'counter'
          },
          {
            'label': '',
            'path':'aberration.THERAPY_AVAILABILITY',
            'type':'indicator-icon-column'
          },
          {
            'label': '',
            'path':'autoEdited',
            'type':'indicator-icon-column'
          },
          {
            'label': 'Include in report',
            'type': 'include_in_report'
          },
          {
            'label': 'Edit',
            'type': 'edit'
          }
        ]
      },
      {
        'type': 'list',
        'name': 'uncharacterizedTherapies',
        'conditions': [{
          'path': 'molecularFinding',
          'value': null,
          'operator': ConditionalOperator.EQ
        }],
        'subjectIdPath': 'aberration.id',
        'subTitle': 'Interpretation not available',
        'fields': [
          {
            'label': 'Gene',
            'path': 'gene.name',
            'type': 'text'
          },
          {
            'label': 'Aberration',
            'path': 'alteration',
            'type': 'text'
          },
          {
            'label': 'Seq. change',
            'path': 'codingSeqChange',
            'type': 'text'
          },
          {
            'label': 'Trials',
            'path': 'trials',
            'type': 'counter'
          },
          {
            'label': 'Include in report',
            'type': 'include_in_report'
          },
          {
            'label': 'Edit',
            'type': 'edit'
          }
        ]
      }],
  },
  'information_section': {
    'tabs': [
      {
        'label': 'Therapies & Trials',
        'count': true,
        'panels': [
          {
            'label': 'Within indication - FDA approved therapies',
            'cssClass': 'treatment-indication  high-rate',
            'resource': 'therapies',
            'path': 'drugs',
            'opened': true,
            'conditions': [{
              'path': 'fdaApprovedForIndication',
              'value': true,
              'operator': ConditionalOperator.EQ
            }],
            'propertiesToStore': [
              {
                dist: 'subjectId',
                source: 'id',
                fallback: '',
              },
              {
                dist: 'subjectType',
                source: 'resourceType',
                fallback: '',
              },
              {
              dist: 'aberration',
              source: 'alteration',
              fallback: '',
            },
              {
                dist: 'gene',
                source: 'gene.name',
                fallback: '',
              }
            ],
            'additionalData': {
              'source': 'within'
            },
            'count': true,
            'selectable': true,
            'type': 'list',
            'fields': [
              {
                'label': 'Therapy',
                'path': 'displayName'
              },
              {
                'label': 'Indication',
                'path': 'diseaseInThisIndication'
              }
            ]
          },
          {
            'label': 'Outside indication - FDA approved therapies',
            'resource': 'therapies',
            'additionalData': {
              'source': 'outside'
            },
            'propertiesToStore': [
              {
                dist: 'subjectId',
                source: 'id',
                fallback: '',
              },
                {
                dist: 'subjectType',
                source: 'resourceType',
                fallback: '',
              },
                {
                dist: 'aberration',
                source: 'alteration',
                fallback: '',
              },
              {
                dist: 'gene',
                source: 'gene.name',
                fallback: '',
              }
            ],
            'path': 'drugs',
            'cssClass': 'treatment-indication medium-rate',
            'conditions': [{
              'path': 'fdaApprovedOutsideIndication',
              'value': true,
              'operator': ConditionalOperator.EQ
            }],
            'selectable': true,
            'type': 'list',
            'count': true,
            'infoFormId': null,
            'fields': [
              {
                'label': 'Therapy',
                'path': 'displayName'
              },
              {
                'label': 'Outside Indication',
                'path': 'diseaseInOtherIndications'
              },
              {
                'label': 'Phase within indication',
                'path': 'fdaStatusWithinIndication'
              }
            ]
          },
          {
            'label': 'Within indication - Investigational therapies',
            'resource': 'therapies',
            'path': 'drugs',
            'propertiesToStore': [
              {
                dist: 'subjectId',
                source: 'id',
                fallback: '',
              },
                {
                dist: 'subjectType',
                source: 'resourceType',
                fallback: '',
              },
                {
                dist: 'aberration',
                source: 'alteration',
                fallback: '',
              },
              {
                dist: 'gene',
                source: 'gene.name',
                fallback: '',
              }
            ],
            'additionalData': {
              'source': 'investigational'
            },
            'cssClass': 'treatment-indication low-rate',
            'conditions': [{
              'path': 'investigationalForIndication',
              'value': true,
              'operator': ConditionalOperator.EQ
            }
            ],
            'selectable': true,
            'infoFormId': null,
            'type': 'list',
            'count': true,
            'fields': [
              {
                'label': 'Therapy',
                'path': 'displayName'
              },
              {
                'label': 'Phase',
                'path': 'fdaStatusWithinIndication'
              }
            ]
          },
          {
            'label': 'Clinical trials',
            'count': true,
            'resource': 'trials',
            'selectable': false,
            'infoFormId': 'clinical_trials',
            'type': 'card',
            'titles': [
              { 'text': '$(name)', 'link': 'https://clinicaltrials.gov/ct2/show/$(trialID)'},
              { 'text': '($(trialID))', 'link': 'https://clinicaltrials.gov/ct2/show/$(trialID)'}
            ],
            'cssClass': 'treatment-indication low-rate',
            'fields': [
              {
                'label': 'Target',
                'path': 'target'
              },
              {
                'label': 'Nearest Recruiting Location',
                'path': 'distance.address'
              },
              {
                'label': 'Age Group',
                'path': 'ageGroup'
              },
              {
                'label': 'Recruitment Status',
                'path': 'status'
              },
              {
                'label': 'Study Phase',
                'path': 'phases'
              },
              {
                'label': 'Contact',
                'path': 'contact'
              }
            ]
          },
          // Don't delete, please see GEN-59919
          // {
          //   'label': 'Resistant to',
          //   'count': true,
          //   'resource': 'trials',
          //   'selectable': false,
          //   'infoFormId': 'resistant_to',
          //   'type': 'card',
          //   'titles': [
          //     { 'text': '$(name)', 'link': 'https://clinicaltrials.gov/ct2/show/$(trialID)'},
          //     { 'text': '($(trialID))', 'link': 'https://clinicaltrials.gov/ct2/show/$(trialID)'}
          //   ],
          //   'cssClass': 'treatment-indication low-rate',
          //   'fields': [
          //     {
          //       'label': 'Target',
          //       'path': 'target'
          //     },
          //     {
          //       'label': 'Nearest Recruiting Location',
          //       'path': 'distance.address'
          //     },
          //     {
          //       'label': 'Age Group',
          //       'path': 'ageGroup'
          //     },
          //     {
          //       'label': 'Recruitment Status',
          //       'path': 'status'
          //     },
          //     {
          //       'label': 'Study Phase',
          //       'path': 'phases'
          //     },
          //     {
          //       'label': 'Contact',
          //       'path': 'contact'
          //     }
          //   ]
          // }
        ]
      },
      {
        'label': 'Aberration information',
        'count': false,
        'panels': [
          {
            'label': 'General information',
            'resource': 'therapies',
            'count': false,
            'selectable': false,
            'opened': true,
            'type': 'text',
            'fields': [
              {
                'label': 'Sent Comment',
                'path': 'sentComment',
                'hideIfEmpty': true
              },
              {
                'label': 'Molecular function',
                'path': 'effect'
              },
              {
                'label': 'Incidence in disease',
                'path': 'incidence[*].value',
                'separator': '<br>'
              },
              {
                'path': 'incidence[*].references.reference[*].referenceId',
                'cssClasses': 'brackets',
                'separator': ', ',
                'hideIfEmpty': true,
                'removeDuplications': true
              },
              {
                'label': 'Role in disease',
                'path': 'gene.roleInCancer'
              }
            ]
          },
          {
            'label': 'Clinical information',
            'resource': 'therapies',
            'count': false,
            'selectable': false,
            'type': 'text',
            'fields': [
              {
                'path': 'diseaseSummary[*].value',
                'separator': '<br>'
              },
              {
                'path': 'diseaseSummary[*].references.reference[*].referenceId',
                'cssClasses': 'brackets',
                'separator': ', ',
                'hideIfEmpty': true,
                'removeDuplications': true
              },
              {
                'label': 'Clinical relevance',
                'path': 'theraputicRelevanceDetails',
                'separator': '<br>'
              }
            ]
          },
          {
            'label': 'Treatment information',
            'resource': 'therapies',
            'count': false,
            'selectable': false,
            'type': 'text',
            'fields': [
              {
                'label': 'Guidelines',
                'path': 'guidlines[*].text',
                'separator': '<br>'
              },
              {
                'label': 'Drug sensitivity',
                'path': 'treatmentApproach'
              },
              {
                'label': 'Drug resistance',
                'path': 'drugResistance'
              },
              {
                'label': 'Interactions',
                'path': 'drugInteractions'
              }
            ]
          },
          {
            'label': 'Diagnostic & Prognostic Significance',
            'resource': 'therapies',
            'count': false,
            'selectable': false,
            'type': 'text',
            'fields': [
              {
                'label': 'Diagnostic significance',
                'path': 'diagnosticSignificance.variant.therapyElements[*].value',
                'separator': '<br>'
              },
              {
                'path': 'diagnosticSignificance.variant.therapyElements[*].references.reference[*].referenceId',
                'cssClasses': 'brackets',
                'separator': ', ',
                'hideIfEmpty': true,
                'removeDuplications': true
              },
              {
                'label': 'Level of evidence',
                'cssClasses': 'label-text',
                'path': 'diagnosticLevelOfEvidence'
              },
              {
                'label': 'Prognostic significance',
                'path': 'prognosticSignificance.variant.therapyElements[*].value',
                'separator': '<br>'
              },
              {
                'path': 'prognosticSignificance.variant.therapyElements[*].references.reference[*].referenceId',
                'cssClasses': 'brackets',
                'separator': ', ',
                'hideIfEmpty': true,
                'removeDuplications': true
              },
              {
                'label': 'Level of evidence',
                'cssClasses': 'label-text',
                'path': 'prognosticLevelOfEvidence'
              }
            ]
          }
        ]
      }
    ]
  },
  'summary_section': {
    'type': null,
    'title': null
  },
  'globals': {
    'maxHeight': '23vh'
  }
};
